export default "__VITE_ASSET__CZDSjMNo__"